import { Expose } from "@nts/std/serialization";
import { IdentityInterface, PinIdentityToDashboardDtoInterface } from '@nts/std/interfaces';

export class PinIdentityToDashboardDto<TIDentity extends IdentityInterface> implements PinIdentityToDashboardDtoInterface<TIDentity> {

    @Expose()
    identity: TIDentity;

    @Expose()
    title: string;
}
